import "./App.css";
import React,{ useState, Suspense, lazy, useEffect } from "react";

import { onAuthStateChanged} from "firebase/auth";
import {auth} from './config/firebase'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";
import ScrollToTop from "react-scroll-to-top";
import PopularPageTv from "./Pages/PopularPageTV";
import Background from "./Components/Background";
import ProtectedRoute from "./Components/ProtectedRoute";
import PageNotFound from "./Pages/PageNotFound";
import FooterPage from "./Pages/FooterPage";
import Loader from "./Components/Loader";
import Loading from "./Components/Loading";
import Auth from "./Pages/Auth";
import SignUp from "./Pages/SignUp";
import Login from "./Pages/Login";
import LoginProtected from './Components/LoginProtected.js'
import List from "./Pages/List";
import Favourites from "./Pages/Favourites";
import Profile from "./Pages/Profile";
import UserProtected from "./Components/UserProtected";
import ListView from "./Pages/ListView";
import NewHome from "./Pages/NewHome.js";
const HomePage =React.lazy(()=>import("./Pages/HomePage")) ;
const  Search =React.lazy(()=>import("./Pages/Search") )
const MovieDetail =React.lazy(()=>import("./Pages/MovieDetail")) ;
const PeopleDetail =React.lazy(()=>import("./Pages/PeopleDetail")) ;
const TvDetail =React.lazy(()=>import("./Pages/TvDetail")) ;
const NowPlaying =React.lazy(()=>import("./Pages/NowPlaying.js")) ;
const PopularPage =React.lazy(()=>import("./Pages/PopularPageMovie")) ;
const PopularPageMovie =React.lazy(()=>import("./Pages/PopularPageMovie")) ;
const EpisodeDetails =React.lazy(()=>import( "./Pages/EpisodeDetails"));


function App() {
  const [user, setuser] = useState(()=>{
    const storedUser =localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser):null
  })
 
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth,(currentUser)=>{
      if(currentUser){
        setuser(currentUser)
        localStorage.setItem('user',JSON.stringify(currentUser));
      }else{
        setuser(null)
        localStorage.removeItem('user')
      }
    })
  
    return () => {
     unsubscribe()
    }
  },[])

  

  return (
    <BrowserRouter>
      <Suspense fallback={<Loading/>}>
    <Navbar user={user}/>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/search" element={<Search />} />
          <Route path="/movie" element={<ProtectedRoute><MovieDetail user={user} /></ProtectedRoute>} />
          <Route path="/tv" element={<ProtectedRoute><TvDetail user={user}  /></ProtectedRoute>} />
          <Route path="/person" element={<ProtectedRoute><PeopleDetail /></ProtectedRoute>} />
          <Route path="/popular/movie" element={<PopularPageMovie />} />
          <Route path="/popular/tv" element={<PopularPageTv />} />
          <Route path="/tv/episode" element={<ProtectedRoute><EpisodeDetails /></ProtectedRoute>} />
          <Route
                    path="*"
                    element={<PageNotFound />}
                />
                <Route path='/auth' element={<Auth/>} />
                <Route path='/login' element={<LoginProtected><Login/></LoginProtected>}/>
                <Route path='/SignUp' element={<LoginProtected><SignUp/></LoginProtected>} />
                <Route path='/list' element={<UserProtected user={user}><List user={user}/></UserProtected>} />
                <Route path='/listView' element={<UserProtected user={user}><ListView user={user}/></UserProtected>} />

                <Route path='/favourite' element={<UserProtected user={user}><Favourites user={user}/></UserProtected>} />
                <Route path='/profile' element={<UserProtected user={user}><Profile user={user}/></UserProtected>} />

        </Routes>
      </Suspense>
      
      
      <ScrollToTop className="animate-bounce relative z-50" smooth viewBox="0 0 20 20" color='#facc15' width='40px' style={{ backgroundColor: 'rgba(4,28,40,1)' , zIndex:'50' }}
          svgPath='M13.889,11.611c-0.17,0.17-0.443,0.17-0.612,0l-3.189-3.187l-3.363,3.36c-0.171,0.171-0.441,0.171-0.612,0c-0.172-0.169-0.172-0.443,0-0.611l3.667-3.669c0.17-0.17,0.445-0.172,0.614,0l3.496,3.493C14.058,11.167,14.061,11.443,13.889,11.611 M18.25,10c0,4.558-3.693,8.25-8.25,8.25c-4.557,0-8.25-3.692-8.25-8.25c0-4.557,3.693-8.25,8.25-8.25C14.557,1.75,18.25,5.443,18.25,10 M17.383,10c0-4.07-3.312-7.382-7.383-7.382S2.618,5.93,2.618,10S5.93,17.381,10,17.381S17.383,14.07,17.383,10' />
      
      {/* <h1> Movie Hinge</h1> 
     <form onSubmit={handleSubmit(onSubmit)}>
      <input type="text" placeholder="Name" {...register("profile.name", {required: true})} />
      <input type="text" placeholder="Email" {...register("profile.email", {required: true})} />
      <input type="password" placeholder="Password" {...register("profile.password", {required: true, maxLength: 11})} />

      <button type="submit" >click</button>
    </form>  */}
    {/* <FooterPage/> */}
    </BrowserRouter>
  );
}

export default App;
